  <template>
  <div class="right">
    <!-- 头部标题 -->
    <RightTop @data="getCreditDataFn"></RightTop>
    <div class="rightCenter">
      <div class="centerTit">营运能力</div>
      <div style="width:80%;position: relative;">
        <div
          @click="downloadFn(0)"
          style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:21px;margin-left:20px;"
        >
          <img
            src="@/assets/img/Excel.png"
            alt
            style="display: inline-block;height: 18px;width:18px;float:left;"
          />
          <span
            style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;"
          >下载数据到Excel</span>
        </div>
        <div style="width:165px;float:right;position: relative;">
          <el-select v-model="searchData1.value" size="small" placeholder="报表范围选择">
            <el-option v-for="item in searchData1.select" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <div
            @click="SelectTimeFn1"
            style="position: absolute;top: 0;left:0;width:100%;height: 100%;cursor: pointer;"
          ></div>
        </div>
        <el-card
          class="box-card SelectAlert"
          style="position: absolute;top:54px;right:19%;width:335px;height:302px;z-index: 1000000;display: none;background:#052b4f;"
        >
          <h5
            style="font-size:14px;font-family:Microsoft YaHei;font-weight:bold;color:#fff;line-height:1;margin-bottom:23px;"
          >日期范围</h5>
          <el-radio-group v-model="changeTime.radio">
            <el-radio :label="2" style="width:40px;color:#fff;">近两年</el-radio>
            <el-radio :label="3" style="width:40px;color:#fff;">近三年</el-radio>
            <el-radio :label="5" style="width:40px;color:#fff;">近五年</el-radio>
            <el-radio :label="10" style="width:40px;color:#fff;">近十年</el-radio>
            <el-radio
              :label="-1"
              style="width:80px;display: inline-block;margin-top:30px;margin-right:0;color:#fff;"
            >自定义</el-radio>
            <el-input
              @focus="startTimeFn"
              @blur="startTimeTestFn(1)"
              v-model="changeTime.startTime"
              placeholder="2010-11"
              size="mini"
              style="display: inline-block;width:90px;"
            ></el-input>
            <span
              style="display: inline-block;width:8px;height: 1px;position: relative;top: -4px;background:#000;margin:0 10px;"
            ></span>
            <el-input
              @focus="startTimeFn"
              @blur="startTimeTestFn(2)"
              v-model="changeTime.endTime"
              placeholder="2010-11"
              size="mini"
              style="display: inline-block;width:90px;"
            ></el-input>
          </el-radio-group>
          <div style="width:98%;height:1px;background:#DFDFDF;margin-top:21px;margin-bottom:20px;"></div>
          <h5
            style="font-size:14px;font-family:Microsoft YaHei;font-weight:bold;color:#fff;line-height:1;"
          >报告期</h5>
          <el-checkbox-group v-model="changeTime.checkedCities" @change="handleCheckedCitiesChange">
            <el-checkbox
              v-for="city in changeTime.cities"
              :label="city"
              :key="city"
              style="width:45px;color:#000000;"
            >{{city}}</el-checkbox>
          </el-checkbox-group>
          <div style="height: 40px;line-height:1;text-align: center;">
            <el-button @click="changeTimeTrue" type="primary" size="mini">确定</el-button>
            <el-button @click="changeTimeClose" type="info" size="mini">关闭</el-button>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 下面表格 -->
    <div class="rightBottom">
      <!-- 矩形图 -->
      <div class="barChart">
        <div id="leftChart"></div>
        <div id="rightChart"></div>
      </div>
      <!-- 第一套 -->
      <el-table
        :data="tableData1"
        :show-header="false"
        border
        size="mini"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column
          v-for="(item,index) in tableData1[0]"
          :prop="index + ''"
          :width="index == 0 ? '250' : 138 "
          :fixed="index == 0 ? true : false "
          :label="item[index + '']"
          :key="index"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import RightTop from "@/components/rightTop.vue";
import echarts from "echarts";
import $ from "jquery";
export default {
  components: {
    RightTop
  },
  data() {
    return {
      tableData1: [],
      //选择数据
      searchData1: {
        select: [], //下拉框选项数据
        value: ""
      },
      stockCode: "",
      enterpriseCode: "",
      paramsData: {}, //URL参数集合
      changeTime: {
        //报表范围选项数据
        radio: "",
        startTime: "",
        endTime: "",
        checkedCities: ["一季度", "中报", "三季度", "年报"],
        cities: ["一季度", "中报", "三季度", "年报"]
      }
    };
  },
  watch: {
    changeTime: {
      handler(val, oldVal) {
        // console.log(val.radio, oldVal.radio,'val1');
        if (val.radio != -1) {
          this.changeTime.endTime = "";
          this.changeTime.startTime = "";
        }
      },
      deep: true //true 深度监听
    }
  },
  methods: {
    //   获取头部数据
    getCreditDataFn(data) {
      this.stockCode = data[0].companyStockCode;
      this.enterpriseCode = data[0].enterpriseCode;
      this.action();
      this.barChart(); //矩形图
      //   console.log(data, 999999999999);
    },

    // 矩形图
    barChart() {
      var leftChart = echarts.init(document.getElementById("leftChart"));
      var rightChart = echarts.init(document.getElementById("rightChart"));
      var option = {
        title: {
          // text: "每股收益",
          left: "center",
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },

        xAxis: [
          {
            type: "category",
            // data: ["Mon", "Tue "],
            axisTick: {
              alignWithLabel: true
            },
            axisTick: {
              // 坐标轴的刻度
              show: false // 是否显示
            },
            axisLine: {
              lineStyle: {
                color: "#fff"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              // 坐标轴的刻度
              show: false
            },
            
            axisLine: {
              lineStyle: {
                color: "#fff"
              }
            }
          }
        ],
        series: [
          {
            // name: "每股收益",
            type: "bar",
            // barWidth: "60%",
            barWidth: 20
            // data: [10, 52, 200]
          }
        ]
      };
      leftChart.setOption(option);
      rightChart.setOption(option);

      let report_time = [];
      let fact_value = [];
      let report_time2 = [];
      let fact_value2 = [];
      //   let averageNum = [];
      api
        .analyzeOperateInventory(this.stockCode, this.enterpriseCode)
        .then(res => {
          // console.log(res.data,111111111111);
          let result = res.data;
          for (var i = result.length - 1; i >= 0; i--) {
            report_time.push(result[i].report_time);
            fact_value.push(result[i].fact_value);
            //   console.log( fact_value,55555555555)
            //   averageNum.push(result[i].averageNum);
          }
          leftChart.setOption({
            title: {
              text: "存货周转率（次）"
            },
            xAxis: {
              //给x轴赋值
              data: report_time
            },
            series: [
              {
                //y轴
                data: fact_value
              }
            ]
          });
        });

      api.analyzeOperateAsset(this.stockCode, this.enterpriseCode).then(res => {
        // console.log(res.data,2222222222222);
        let result = res.data;
        for (var i = result.length - 1; i >= 0; i--) {
          report_time2.push(result[i].report_time);
          fact_value2.push(result[i].fact_value);
          //   console.log( fact_value,55555555555)
          //   averageNum.push(result[i].averageNum);
        }
        rightChart.setOption({
          title: {
            text: "总资产周转率（次）"
          },
          xAxis: {
            //给x轴赋值
            data: report_time2
          },
          series: [
            {
              //y轴
              data: fact_value2
            }
          ]
        });
      });
    },

    //筛选条件确定按钮
    changeTimeTrue() {
      let startDate = "";
      let endDate = "";
      let reportDate = "";

      if (this.changeTime.radio == -1) {
        //开始结束时间写了就要写完整
        if (this.changeTime.startTime == "") {
          this.$message.error("请填写开始时间！");
          return;
        }
        if (this.changeTime.endTime == "") {
          this.$message.error("请填写结束时间！");
          return;
        }
        startDate = this.changeTime.startTime;
        endDate = this.changeTime.endTime;
      } else {
        if (this.changeTime.radio == "") {
          startDate = "";
          endDate = "";
        } else {
          startDate = magic
            .getSomeYearsBefor(this.changeTime.radio)
            .substring(0, 7);
          endDate = magic.getSomeYearsBefor(0).substring(0, 7);
        }
      }
      if (this.changeTime.checkedCities.length == 0) {
        //报告期要至少选一个
        this.$message.error("请选择报告期！");
        return;
      }
      let tmpArr = this.changeTime.checkedCities;
      for (var i = 0; i < tmpArr.length; i++) {
        if (tmpArr[i] == "一季度") {
          tmpArr.length - 1 == i ? (reportDate += "03") : (reportDate += "03,");
        }
        if (tmpArr[i] == "中报") {
          tmpArr.length - 1 == i ? (reportDate += "06") : (reportDate += "06,");
        }
        if (tmpArr[i] == "三季度") {
          tmpArr.length - 1 == i ? (reportDate += "09") : (reportDate += "09,");
        }
        if (tmpArr[i] == "年报") {
          tmpArr.length - 1 == i ? (reportDate += "12") : (reportDate += "12,");
        }
      }
      // console.log(startDate, endDate, reportDate);

      setTimeout(() => {
        this.fetchTable1(
          this.stockCode,
          this.enterpriseCode,
          startDate,
          endDate,
          reportDate
        ); //按产品
        $(".el-table thead tr th").css({
          background: "#F7F7F7",
          color: "#333",
          "font-size": "14px",
          "font-weight": "400"
        });
        $(".SelectAlert").css("display", "none");
      }, 900);
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
          LogCollection.send(9);
      }catch(e){}
    },
    //日期正则校验
    isDate(dateString) {
      if (dateString.trim() == "") return false;
      //年月日正则表达式
      var r = dateString.match(/^(\d{1,4})(-)(\d{1,2})$/);
      if (r == null) {
        return false;
      }
      return true;
    },
    //筛选条件关闭按钮
    changeTimeClose() {
      $(".SelectAlert").css("display", "none");
    },
    //日期范围里时间段input函数
    startTimeFn() {
      this.changeTime.radio = -1;
    },
    // 日期输入框正则校验
    startTimeTestFn(num) {
      let bool = "";
      if (num == 1) {
        bool = this.isDate(this.changeTime.startTime);
      }
      if (num == 2) {
        bool = this.isDate(this.changeTime.endTime);
      }
      if (!bool) {
        this.$message.error("请输入正确的时间格式！");
        num == 1
          ? (this.changeTime.startTime = "")
          : (this.changeTime.endTime = "");
      }
    },
    //多选框函数
    handleCheckedCitiesChange(value) {
      console.log(value, "value");
    },
    cellStyle(row, column, rowIndex, columnIndex) {
      if (row.columnIndex == 0 || row.rowIndex == 0) {
        return "color: #fff;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;";
      }
    },
    geturlParams() {
      // 获取URL参数
      let stockCode = magic.getUrlKey("stockCode");
      let enterpriseCode = magic.getUrlKey("enterpriseCode");
      let library = magic.getUrlKey("library");
      let creditCode = magic.getUrlKey("creditCode");
      this.paramsData["stockCode"] = stockCode;
      this.paramsData["enterpriseCode"] = enterpriseCode;
      this.paramsData["library"] = library;
      this.paramsData["creditCode"] = creditCode;
    },

    //下载函数
    downloadFn(incomeType) {
      let _this = this;
      //收入类型分类 0:按产品 1:按行业 2:按地域
      let reportDate = "";
      if (incomeType == 0) {
        reportDate = this.searchData1.value;
      } else if (incomeType == 1) {
        reportDate = this.searchData2.value;
      } else if (incomeType == 2) {
        reportDate = this.searchData3.value;
      }
      this.download(
        window.baseUrl +
          "/financialAnalysis/downOperationalCapabilityData?stockCode=" +
          this.stockCode +
          "&enterpriseCode=" +
          this.enterpriseCode +
          "&incomeType=" +
          incomeType +
          "&reportDate=" +
          reportDate
      );
      // api.baseInfoTableDown(this.stockCode,this.enterpriseCode,incomeType,reportDate).then(res=>{
      //   let data = res.data;
      //   console.log(data,'data');
      //   _this.download(data,'测试')
      // })
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    download(url) {
      let a = document.createElement("a");
      a.href = url;
      let _id = Math.random() + Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    //第一个下拉框
    SelectTimeFn1(val) {
      let state = $(".SelectAlert").css("display");
      if (state == "block") {
        $(".SelectAlert").css("display", "none");
      } else {
        $(".SelectAlert").css("display", "block");
      }
    },
    action() {
      setTimeout(() => {
        this.fetchTable1(this.stockCode, this.enterpriseCode, "", "", ""); //按产品
        $(".el-table thead tr th").css({
          background: "#F7F7F7",
          color: "#333",
          "font-size": "14px",
          "font-weight": "400"
        });
      }, 900);
    },
    fetchTable1(stockCode, enterpriseCode, startDate, endDate, reportDate) {
      let _this = this;
      let params = {};
      if (startDate == "" && endDate == "" && reportDate == "") {
        params = {
          stockCode: stockCode,
          enterpriseCode: enterpriseCode
        };
      } else {
        params = {
          stockCode: stockCode,
          enterpriseCode: enterpriseCode,
          startDate: startDate,
          endDate: endDate,
          reportDate: reportDate
        };
      }

      api.analyzeOperate(params).then(res => {
        let data = res.data;
        // console.log(data, "data1");
        _this.tableData1 = data;
      });
    }
  },
  created() {
    this.geturlParams();
  },
  mounted() {}
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    overflow: hidden;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    background: #fff;
    .barChart {
      width: 100%;
      height: 377px;
      // background: lawngreen;
      display: flex;
      justify-content: space-between;
      #leftChart {
        width: 50%;
        height: 337px;
        padding-left: 30px;
        padding-right: 30px;
      }
      #rightChart {
        padding-left: 30px;
        padding-right: 30px;
        width: 50%;
        height: 337px;
        // background: lightcoral;
      }
    }
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
      overflow: hidden;
    }
  }
}
.mailTable,
.mailTable tr,
.mailTable tr td {
  border: 1px solid #dfdfdf;
}
.mailTable {
  font-size: 14px;
  color: #4b4b4b;
  width: 100%;
  font-family: Microsoft YaHei;
}
.mailTable tr td {
  border: 1px solid #dfdfdf;
  width: 80%;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  padding: 0 10px;
}
.column {
  background-color: #f7f7f7;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  width: 20%;
}
.el-table thead {
  background-color: #f7f7f7 !important;
  color: #333333 !important;
  font-size: 14px !important;
  font-weight: bold !important;
}
</style>


// WEBPACK FOOTER //
// src/view/analyze/operate.vue